export default "__VITE_ASSET__CSaGrdil__"